const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: 8,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(100vw - 32px)',
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
})

export default styles
